import baseService from '../shared/baseService';

const productService = () =>
    baseService('products');

export default { 
    productService
};

